import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { OnboardingStateService } from '../services/onboarding-state.service';

export const onboardingGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const stateService = inject(OnboardingStateService);
  const router = inject(Router);

  const fromOnboarding = route.queryParamMap.get('fromOnboarding');

  if (fromOnboarding === 'true') {
    return true;
  }

  const isComplete = await stateService.loadOnboardingStatusAsync();

  if (isComplete) {
    return true;
  }

  return router.createUrlTree(['/onboarding']);
};
